// extracted by mini-css-extract-plugin
export default {"root":"menuBtn-module--root--QHRqp","active":"menuBtn-module--active--vGXTy","crossLeft":"menuBtn-module--crossLeft--G9YX6","crossRight":"menuBtn-module--crossRight--tW9DG"};